export class AmsType {
  constructor(code, name) {
    this.code = code
    this.name = name
  }
}

export const ORIGINAL = new AmsType(0, '原始')
export const CORRECT = new AmsType(1, '更正')
export const DELETE = new AmsType(2, '删除')
export const DELETE_CUSTOMS = new AmsType(3, '删除（海关删除，企泰保留）')
export const DELETE_ALL = new AmsType(4, '删除（企泰海关都删除）')
export const LATE_ORIGINAL = new AmsType(5, '晚申')
export const SAVE = new AmsType(6, '仅保存发送')
